<template>
    <app-layout>
        <asset-details-header v-if="asset" />
        <div class="py-6">
            <work-order-board :selected-work-order="page.props.selectedWorkOrder" :swimlanes="swimlanes" class="pb-3" />

            <h3 class="h5 flex items-center gap-1 px-2 py-2">
                {{ trans('assets.workorders.records.title') }}
                <info-icon :tooltip="trans('assets.workorders.records.info')" style="position: relative; top: -1px" />
            </h3>

            <work-order-records :work-orders="archivedWorkOrders" />
        </div>
    </app-layout>
</template>
<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import AssetDetailsHeader from '@/Pages/Assets/Details/AssetDetailsHeader.vue';
import WorkOrderRecords from '@/Pages/WorkOrders/WorkOrderRecords.vue';
import WorkOrderBoard from '@/Pages/WorkOrders/WorkOrderBoard.vue';
import InfoIcon from '@/Components/InfoIcon.vue';
import { usePage } from '@inertiajs/vue3';
import { useWorkOrderStore } from '@/stores/workOrders';
import { computed, onBeforeUnmount, onMounted } from 'vue';

const page = usePage();
const workOrderStore = useWorkOrderStore();

const asset = computed(() => page.props.asset);
const archivedWorkOrders = computed(() => page.props.archivedWorkOrders ?? {});
const swimlanes = computed(() => page.props.swimlanes);

// Run synchronously at setup time so child onMounted hooks see the correct params.
// Otherwise we might have a race condition where the asset is not yet loaded when the work order store is setup
// and the asset is not in the query params showing all work orders of all assets in the records.
if (asset.value) {
    workOrderStore.setup();
    workOrderStore.setQueryParams({
        assets: [asset.value.id],
    });
}

onMounted(() => {
    workOrderStore.reloadLanes();
});

onBeforeUnmount(() => {
    workOrderStore.dispose();
});
</script>
